// extracted by mini-css-extract-plugin
export default {"FooterContainer":"Footer_FooterContainer__1cRit","ContentColumn":"Footer_ContentColumn__k6+-A","mainContainer":"Footer_mainContainer__Sylb2"};